import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from 'store';

const PrivateRoute = ({ children }) => {
  const token = useAuthStore((state) => state.token);
  const companyId = useAuthStore((state) => state.companyId);
  
  if (!token) {
    return <Navigate to={`/login/${companyId || ''}`} />
  }

  return children
};

export default PrivateRoute;